import { IAutoPartsFreeShipping } from "api/interfaces/static-pages/auto-parts-free-shipping-canada.type";
import Index from "container/shipping-information/shipping-informationV2.container";

export default function AutoPartsFreeShipping(props: IAutoPartsFreeShipping) {
  return <Index {...props} />;
}
